/**
 * Emotion Configuration
 * 
 * Re-exports from @wfvr/types which is the SINGLE SOURCE OF TRUTH.
 */

// Re-export everything from the single source of truth
export {
  // Full emotion set (24 emotions for training)
  AVAILABLE_EMOTIONS,
  // Reduced emotion set (10 emotions for game mode)
  GAME_EMOTIONS,
  // Types
  type EmotionType,
  type GameEmotionType,
  // Utils
  DEFAULT_EMOTION,
  isValidEmotion,
  isValidGameEmotion,
  mapToGameEmotion,
  EMOTION_DESCRIPTIONS,
} from '@wfvr/types';

import type { EmotionType, GameEmotionType } from '@wfvr/types';

export function getEmotionImagePath(emotion: EmotionType | GameEmotionType): string {
  return `/avatar-emotions/${emotion}.png`;
}
